(function() {
  'use strict';

  /* ============================================
     CART DRAWER
  ============================================ */

  const cartToggle = document.querySelectorAll('[data-cart-toggle]');
  const cartClose = document.querySelectorAll('[data-cart-close]');
  const cartDrawer = document.getElementById('cart-drawer');
  const cartOverlay = document.getElementById('cart-overlay');

  function openCart() {
    if (!cartDrawer) return;
    cartDrawer.classList.add('open');
    if (cartOverlay) cartOverlay.classList.add('open');
    document.body.style.overflow = 'hidden';
  }

  function closeCart() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('open');
    if (cartOverlay) cartOverlay.classList.remove('open');
    document.body.style.overflow = '';
  }

  cartToggle.forEach(function(btn) {
    btn.addEventListener('click', openCart);
  });

  cartClose.forEach(function(btn) {
    btn.addEventListener('click', closeCart);
  });

  if (cartOverlay) {
    cartOverlay.addEventListener('click', closeCart);
  }

  /* ============================================
     SEARCH OVERLAY
  ============================================ */

  const searchToggle = document.querySelectorAll('[data-search-toggle]');
  const searchClose = document.querySelectorAll('[data-search-close]');
  const searchOverlay = document.getElementById('search-overlay');

  function openSearch() {
    if (!searchOverlay) return;
    searchOverlay.removeAttribute('hidden');
    requestAnimationFrame(function() {
      searchOverlay.classList.add('open');
      const input = searchOverlay.querySelector('input[type="search"]');
      if (input) input.focus();
    });
  }

  function closeSearch() {
    if (!searchOverlay) return;
    searchOverlay.classList.remove('open');
    setTimeout(function() { searchOverlay.setAttribute('hidden', ''); }, 300);
  }

  searchToggle.forEach(function(btn) {
    btn.addEventListener('click', openSearch);
  });

  searchClose.forEach(function(btn) {
    btn.addEventListener('click', closeSearch);
  });

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      closeSearch();
      closeCart();
      closeMobileNav();
    }
  });

  /* ============================================
     MOBILE NAV
  ============================================ */

  const navToggle = document.querySelector('.nav-toggle');
  const mobileNav = document.getElementById('mobile-nav');
  const navClose = document.querySelector('[data-nav-close]');
  const navOverlay = document.querySelector('[data-nav-overlay]');

  function openMobileNav() {
    if (!mobileNav) return;
    mobileNav.removeAttribute('hidden');
    requestAnimationFrame(function() {
      if (navOverlay) navOverlay.classList.add('open');
    });
    document.body.style.overflow = 'hidden';
  }

  function closeMobileNav() {
    if (!mobileNav) return;
    mobileNav.setAttribute('hidden', '');
    if (navOverlay) navOverlay.classList.remove('open');
    document.body.style.overflow = '';
  }

  if (navToggle) navToggle.addEventListener('click', openMobileNav);
  if (navClose) navClose.addEventListener('click', closeMobileNav);
  if (navOverlay) navOverlay.addEventListener('click', closeMobileNav);

  /* ============================================
     CART COUNT UPDATE
  ============================================ */

  function updateCartCount(count) {
    document.querySelectorAll('.cart-count').forEach(function(el) {
      el.textContent = count;
    });
  }

  /* ============================================
     ANNOUNCEMENT MARQUEE (clone for seamless loop)
  ============================================ */

  const marquee = document.querySelector('.announcement-bar__marquee');
  if (marquee) {
    const clone = marquee.innerHTML;
    marquee.innerHTML = clone + clone;
  }

  /* ============================================
     COLLECTION FILTERS (URL-based, handled server-side)
     Active state is set via Liquid class in the template
  ============================================ */

})();
